import { c as _c } from "react/compiler-runtime";
import { DateTimePicker, FormInput, Modal, PrimaryButton, setDateWithTimezone } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { ResendNewsletterErrorResponseContentInterface } from 'modules/newsletters/single/types/error-response-content-interface';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { filterPassedTime } from 'shared/utils/date-time-format';
export interface ResendNewsletterModalWithoutButtonProps {
  opened: boolean;
  subject: string;
  onClose: () => void;
  onResend: (data: any) => Promise<void>;
}
interface ErrorsInterface {
  scheduledAt?: string;
  subject?: string;
  common?: string;
}
const defaultErrors = {
  scheduledAt: '',
  subject: '',
  common: ''
};
const ResendNewsletterModalWithoutButton = t0 => {
  const $ = _c(54);
  const {
    subject,
    opened,
    onClose,
    onResend
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const [time, setTime] = useState(null);
  const [tempValue, setTempValue] = useState(subject);
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] !== onClose || $[1] !== onResend || $[2] !== tempValue || $[3] !== time) {
    t1 = async () => {
      ;
      try {
        setIsFetching(true);
        await onResend({
          scheduledAt: time,
          subject: tempValue
        });
        setIsFetching(false);
        onClose();
        setErrors(defaultErrors);
      } catch (t2) {
        const e = t2;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          const error = e.errors as ResendNewsletterErrorResponseContentInterface;
          if (e.errors.common) {
            setErrors(prev => ({
              ...prev,
              common: error.common.join("")
            }));
          }
          const fields = !Array.isArray(error.fields) ? error.fields : undefined;
          if (fields) {
            setErrors(prev_0 => ({
              ...prev_0,
              subject: fields.subject?.join(""),
              scheduledAt: fields.scheduledAt?.join("")
            }));
          }
        }
      }
    };
    $[0] = onClose;
    $[1] = onResend;
    $[2] = tempValue;
    $[3] = time;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleResend = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("dashboard.newsletter.resend_title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("dashboard.newsletter.subject_title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => setTempValue(e_0.target.value);
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== errors.subject || $[11] !== t3 || $[12] !== tempValue) {
    t5 = <div className="flex flex-col justify-center gap-3"><FormInput label={t3} value={tempValue} onChange={t4} error={errors.subject} /></div>;
    $[10] = errors.subject;
    $[11] = t3;
    $[12] = tempValue;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("dashboard.newsletter.send_at_title");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = user?.timezone;
  let t8;
  if ($[16] !== t7) {
    t8 = setDateWithTimezone("", t7);
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== user?.timezone) {
    t9 = time_0 => filterPassedTime(time_0, user?.timezone);
    $[18] = user?.timezone;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = {
      minDate: t8,
      filterTime: t9
    };
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = user?.createdAt;
  const t12 = user?.timezone;
  const t13 = user?.dateFormat;
  const t14 = user?.timeFormat;
  let t15;
  if ($[23] !== errors.scheduledAt || $[24] !== intlLocale || $[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t6 || $[31] !== time) {
    t15 = <div className="flex flex-col justify-center gap-3"><DateTimePicker value={time} onChange={setTime} label={t6} customProps={t10} error={errors.scheduledAt} createdAt={t11} timezone={t12} userDateFormat={t13} userTimeFormat={t14} intlLocale={intlLocale} /></div>;
    $[23] = errors.scheduledAt;
    $[24] = intlLocale;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t6;
    $[31] = time;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== handleResend) {
    t16 = async e_1 => {
      e_1.preventDefault();
      await handleResend();
    };
    $[33] = handleResend;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t) {
    t17 = t("dashboard.newsletter.duplicate_and_send");
    $[35] = t;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== isFetching || $[38] !== t16 || $[39] !== t17) {
    t18 = <div className="flex justify-center gap-4"><PrimaryButton onClick={t16} isFetching={isFetching}>{t17}</PrimaryButton></div>;
    $[37] = isFetching;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== errors.common) {
    t19 = errors.common && <p className="text-danger [&_a]:primary-link text-center text-sm" dangerouslySetInnerHTML={{
      __html: errors.common
    }} />;
    $[41] = errors.common;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t15 || $[44] !== t18 || $[45] !== t19 || $[46] !== t5) {
    t20 = <form className="flex flex-col gap-6 lg:gap-7">{t5}{t15}{t18}{t19}</form>;
    $[43] = t15;
    $[44] = t18;
    $[45] = t19;
    $[46] = t5;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== isFetching || $[49] !== onClose || $[50] !== opened || $[51] !== t2 || $[52] !== t20) {
    t21 = <Modal opened={opened} onClose={onClose} title={t2} isFetching={isFetching}>{t20}</Modal>;
    $[48] = isFetching;
    $[49] = onClose;
    $[50] = opened;
    $[51] = t2;
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  return t21;
};
export default ResendNewsletterModalWithoutButton;